import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Program } from '@clearroadlab/cam';

import { environment } from '../../environments/environment';
import { filterParams, handleAPIError, ISearchParams } from '../utils';
import { UsersService } from '../users/users.service';

const path = `${environment.camApi.baseUrl}/programs`;

export interface IProgramSearchParams extends ISearchParams {
  search?: string;
  searchIN?: string[];
}

export class ProgramSearchResult {
  count = 0;
  results: Program[];
}

@Injectable({
  providedIn: 'root'
})
export class ProgramsService {
  public program: Partial<Program>;
  public programStatic: any;

  constructor(
    private http: HttpClient,
    private usersService: UsersService
  ) {}

  headers(key?: string) {
    return {
      ...this.usersService.headers,
      ...(key ? {'X-PROGRAM-KEY': key} : {})
    };
  }

  async create(data: Program) {
    return this.http.post<Program>(path, data, {
      headers: this.headers()
    }).toPromise().catch(handleAPIError);
  }

  async get(key: string) {
    return this.http.get<Program>(path, {
      headers: this.headers(key)
    }).toPromise().catch(handleAPIError);
  }

  async list(params?: IProgramSearchParams) {
    return this.http.get<ProgramSearchResult>(`${path}/all`, {
      headers: this.usersService.headers,
      params: filterParams(params)
    }).toPromise().catch(handleAPIError);
  }

  async getStatic(key?: string) {
    return this.http.get<any>(`${path}/static`, {
      headers: this.headers(key)
    }).toPromise().catch(handleAPIError);
  }

  async update(key: string, data: Program) {
    return this.http.put<Program>(`${path}/${key}`, data, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }

  async updateStatic(data: any, key?: string) {
    return await this.http.put<any>(`${path}/static`, data, {
      headers: this.headers(key)
    }).toPromise().catch(handleAPIError);
  }

  async refreshPricing(key: string) {
    return this.http.put<void>(`${path}/${key}/pricing`, {}, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }
}
